import { render, staticRenderFns } from "./StatsKpiCellGoal.vue?vue&type=template&id=1072c07d&scoped=true&"
import script from "./StatsKpiCellGoal.vue?vue&type=script&lang=js&"
export * from "./StatsKpiCellGoal.vue?vue&type=script&lang=js&"
import style0 from "./StatsKpiCellGoal.vue?vue&type=style&index=0&id=1072c07d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1072c07d",
  null
  
)

export default component.exports